/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const setUrlWithParams = (url, paramsObj) => {
  const curUrl = new URL(url)
  if (paramsObj) {
    Object.keys(paramsObj).forEach(param => {
      const paramValue = paramsObj[param]
      const isValidParam = paramValue !== undefined && paramValue !== null && paramValue !== ''

      isValidParam &&
        curUrl.searchParams.append(param, paramValue)
    })
  }

  return curUrl.href
}

export const getUrlWithoutSearchParams = url => {
  const index = url.indexOf('?')

  return index !== -1
    ? url.substring(0, index)
    : url
}
export const getSearchParams = () => {
  const searchParams = Object.fromEntries(
    new URLSearchParams(window.location.search)
  )
  const baseUrl = getUrlWithoutSearchParams(window.location.href)

  return { searchParams, baseUrl }
}

export const removeSearchParams = () => {
  const url = window.location.pathname

  window.history.replaceState({}, '', url)
}

export const applyFilterParams = (newSearchParams = {}, onFilterResults) => {
  const { baseUrl, searchParams: currentSearchParams } = getSearchParams()
  const { page, ...searchParams } = currentSearchParams
  const updatedSearchParams = {
    ...searchParams,
    ...newSearchParams
  }
  const url = setUrlWithParams(
    baseUrl,
    updatedSearchParams
  )

  window.history.pushState({}, '', url)

  onFilterResults && onFilterResults(updatedSearchParams)
}
